




import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "ProfileHeaderAvatar",
  components: { BaseAvatar },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
    animate: { type: Boolean, default: false },
    showStoryCreateBtn: { type: Boolean, default: false },
    showStoryInfo: { type: Boolean, default: false },
  },
});
